module.exports = __webpack_public_path__ + "img/miset2.09363aa2.jpg";